import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import SliderHomeContainer from '../home/containers/sliderhomecontainer.component';
import RecentSoonMoviesContainer from '../movies/containers/recentsoonmoviescontainer.component';

import HomeCards from '../homecards/homecards.component';
import RecommendedForYou from '../recommendedforyou/recommendedforyou.component';
// import BoxOfficeSmall from '../boxoffice/boxofficesmall.component';
import Ads from '../ads/ads.component';
import LastCommments from '../lastcomments/lastcomments.component';
import FacebookLikesBox from '../facebooklikesbox/facebooklikesbox.component';
import Spinner from '../../../SHARED/components/spinner/spinner.component';
import { pageViewEvent } from '../../../SHARED/helpers/general.helper';
import { Helmet } from 'react-helmet';

const CANONICAL_URL = 'https://cinemap.ro';
class Home extends Component {

    componentWillMount() {
        window.prerenderReady = false;
        window.scrollTo(0, 0);
    }

    componentDidMount() {
        pageViewEvent('Cinemap',window.location.protocol + "//" + window.location.host + '/');  
     }
    
     componentWillReceiveProps(nextProps){
        if(nextProps.loading === 0 && !window.prerenderReady){
            this.handleLoad();
        }
     }

     handleLoad(){
        window.prerenderReady = true;
     }
    
    render() {
        return (
            <div className="home">
                <Spinner /> 
                <Helmet>
                    <title>Cinemap</title>
                    <meta name="description" content="Cinemap. Ultimele informații despre filme, seriale, festivale. Program cinema pentru fimele tale preferate. Știri, articole despre cele mai recente evenimente."/>
                    <meta name="keywords" content="cinemap, filme, seriale, festivale, program cinema, stiri, articole, cinema"/>
                    <link rel="canonical" href={CANONICAL_URL}/>

                    <meta property="og:url"                content={CANONICAL_URL} />
                    <meta property="og:type"               content="website" />
                    <meta property="og:title"              content={`Cinemap`} />
                    <meta property="og:description"        content={`Cinemap. Ultimele informații despre filme, seriale, festivale. Program cinema pentru fimele tale preferate. Știri, articole despre cele mai recente evenimente.`} />
                    <meta property="og:image"              content={""} />

                    <meta name="twitter:card" content="summary" />
                    <meta name="twitter:site" content={CANONICAL_URL} />
                    <meta name="twitter:title" content={`Cinemap`} />
                    <meta name="twitter:description" content={`Cinemap. Ultimele informații despre filme, seriale, festivale. Program cinema pentru fimele tale preferate. Știri, articole despre cele mai recente evenimente.`} />
                    <meta name="twitter:image" content={""} />
                </Helmet>
                <div className="container-fluid nopadding">
                    <SliderHomeContainer />
                    {   window.innerWidth > 1000 ? 
                        <Ads
                            id="div-gpt-ad-1662463178982-0"
                            slave="googletag.cmd.push(function() { googletag.display('div-gpt-ad-1662463178982-0'); googletag.pubads().refresh();});"
                        /> : 
                        <Ads
                            id="div-gpt-ad-1662463706379-0"
                            slave="googletag.cmd.push(function() { googletag.display('div-gpt-ad-1662463706379-0'); googletag.pubads().refresh();});"
                        />
                    }
                    
                    <RecentSoonMoviesContainer />
                    {/*<HomeCards />*/}
                </div>

                <div className="section-headline">
                    ULTIMELE ARTICOLE
                </div>

                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-9">
                            <RecommendedForYou component={"home"} />
                        </div>

                        <div className="col-md-3">
                            {/* <BoxOfficeSmall /> */}
                            <Ads
                                id="div-gpt-ad-1662463314968-0"
                                slave="googletag.cmd.push(function() { googletag.display('div-gpt-ad-1662463314968-0'); });"
                            />
                            <LastCommments />
                            <FacebookLikesBox />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.loading.pendingRequests
});
export default withRouter(connect(mapStateToProps, {})(Home));



// WEBPACK FOOTER //
// ./src/FO/components/home/home.component.js